import { zodResolver } from '@hookform/resolvers/zod'
import type { KeyboardEvent } from 'react'
import { useForm } from 'react-hook-form'

import AtomButton from '@/components/Atoms/AtomButton/AtomButton'
import StoreCreationFields from '@/components/EntityCreationModals/StoreCreationModal/StoreCreationFields'
import {
  buildStoreFormDefaults,
  type StoreCreationFormType,
  storeCreationSchema,
} from '@/components/EntityCreationModals/StoreCreationModal/StoreCreationModal.config'
import handleFormSubmitError from '@/utils/forms/handleFormSubmitError'

import cn from './SupplierNewStoreForm.module.scss'

type SupplierNewStoreFormProps = {
  isOrganisationSelected: boolean
  onAdd: (values: StoreCreationFormType) => void
  onCancel: () => void
}

function SupplierNewStoreForm({
  isOrganisationSelected,
  onAdd,
  onCancel,
}: SupplierNewStoreFormProps) {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<StoreCreationFormType>({
    resolver: zodResolver(storeCreationSchema),
    defaultValues: buildStoreFormDefaults(null, null),
    mode: 'onTouched',
    shouldFocusError: false,
  })

  const addStore = () =>
    void handleSubmit(onAdd, () => handleFormSubmitError(false))()

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== 'Enter' || !(event.target instanceof HTMLInputElement))
      return
    event.preventDefault()
    addStore()
  }

  return (
    <div
      role="group"
      aria-label="Новый склад"
      className={cn.nestedForm}
      onKeyDown={handleKeyDown}
    >
      <p className={cn.title}>Новый склад</p>
      <StoreCreationFields
        control={control}
        register={register}
        errors={errors}
        supplierOptions={[]}
        showSupplierSelect={false}
        isOrganisationSelected={isOrganisationSelected}
      />
      <div className={cn.actions}>
        <AtomButton variant="secondary" onClick={onCancel}>
          Отмена
        </AtomButton>
        <AtomButton onClick={addStore}>Добавить склад</AtomButton>
      </div>
    </div>
  )
}

export default SupplierNewStoreForm
